import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { PadObservacionesService } from "../../servicios/pad-observaciones.service";
import { AguasService } from "../../servicios/aguas.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { Medidores, PadObservaciones } from "../../entidades/entidades";
import { Aguas } from "../../entidades/entidades";
import { CatUsuarios } from "../../entidades/entidades";
@Component({
  selector: "app-pad-observaciones-grid",
  templateUrl: "./pad-observaciones-grid.component.html",
  styleUrls: ["./pad-observaciones-grid.component.css"],
})
export class PadObservacionesGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  aguas: SelectItem[];
  catUsuarios: SelectItem[];
  padObservaciones: PadObservaciones[] = [];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedPadObservaciones: { [s: string]: PadObservaciones } = {};
  @Input("observacionesInput") observacionesInput: Medidores;
  public progressBar = false ;

  constructor(
   private padObservacionesService: PadObservacionesService,
    private aguasService: AguasService,
    private catUsuariosService: CatUsuariosService,
  ) {}

  async ngOnChanges(changes: SimpleChanges) {
    if(this.observacionesInput.idAgua)
    {
      this.padObservaciones = [];
      await this.getAllPadObservaciones();
    }

  }

  async ngOnInit() {
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridPadObservaciones();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "", ordenar: false, styleHeader: "width: 30px;"},
     // {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
      {field: "observacion", header: "Observacion",ordenar: true, styleHeader: "width: 150px;",},
      {field: "idUsuario", header: "Usuario",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fecha", header: "Fecha",ordenar: true, styleHeader: "width: 150px;",},
      {field: "hora", header: "Hora",ordenar: true, styleHeader: "width: 150px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let padObservacionesNew = new PadObservaciones();
    padObservacionesNew.cambio = true;
    padObservacionesNew.id = 0;
    const currentDate: Date = new Date();
    padObservacionesNew.fecha = currentDate;
    padObservacionesNew.hora = currentDate.toLocaleTimeString(); 
    padObservacionesNew.idAgua = this.observacionesInput.idAgua;
    padObservacionesNew.numRow = this.padObservaciones.length + 1;
    this.padObservaciones.unshift(padObservacionesNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let padObservacionesEdit = event.data;
    this.clonedPadObservaciones[padObservacionesEdit.numRow] = { ...padObservacionesEdit };
    padObservacionesEdit.cambio = true;
    padObservacionesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let padObservacionesEdit = event.data;
    let index = this.padObservaciones.findIndex(
      (obj) => obj.numRow === padObservacionesEdit.numRow
    );
    this.padObservaciones[index] = { ...this.clonedPadObservaciones[padObservacionesEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let padObservacionesEdit = event.data;

      //Valida si hay cambios
      if (
        padObservacionesEdit.id === this.clonedPadObservaciones[padObservacionesEdit.numRow].id &&
        padObservacionesEdit.idAgua === this.clonedPadObservaciones[padObservacionesEdit.numRow].idAgua &&
        padObservacionesEdit.observacion === this.clonedPadObservaciones[padObservacionesEdit.numRow].observacion &&
        padObservacionesEdit.idUsuario === this.clonedPadObservaciones[padObservacionesEdit.numRow].idUsuario &&
        padObservacionesEdit.fecha === this.clonedPadObservaciones[padObservacionesEdit.numRow].fecha 
      ) {
        let index = this.padObservaciones.findIndex((obj) => obj.numRow === padObservacionesEdit.numRow);
        this.padObservaciones[index] = {...this.clonedPadObservaciones[padObservacionesEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      padObservacionesEdit.cambio = true;
      padObservacionesEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridPadObservaciones() {
    try {
      for (let padObservacionesFor of this.padObservaciones) {
        if (padObservacionesFor.baja) {
          await this.deletePadObservaciones(padObservacionesFor);
        } else if (padObservacionesFor.cambio) {
          padObservacionesFor.cambio = false;
          this.clonedPadObservaciones[padObservacionesFor.id] = { ...padObservacionesFor, };
          if (padObservacionesFor.id === 0) {
            await this.addPadObservaciones(padObservacionesFor);
            await this.getAllPadObservaciones();
          } else {
            await this.updatePadObservaciones(padObservacionesFor);
            await this.getAllPadObservaciones();
          }
        }
      }

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarPadObservaciones");
    }
  }

  // prettier-ignore
  async addPadObservaciones(padObservaciones) {
    try {
       await this.padObservacionesService
        .add(padObservaciones)
        .toPromise();
      
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por addPadObservaciones");
    }
  }

  // prettier-ignore
  async getAllPadObservaciones() {
    try {
      this.progressBar = true;
      this.padObservaciones = [];
      const datoRetorno = await this.padObservacionesService.getSingle(this.observacionesInput.idAgua).toPromise();
      if(datoRetorno)
      {
        for (let index = 0; index < Object.keys(datoRetorno).length; index++) {
          let padObservacionesNew   = new PadObservaciones();
          padObservacionesNew.id    = datoRetorno[index].id;
          padObservacionesNew.idAgua    = datoRetorno[index].idAgua;
          padObservacionesNew.fecha = datoRetorno[index].fecha;
          padObservacionesNew.observacion = datoRetorno[index].observacion;
          padObservacionesNew.nombreUsuario = datoRetorno[index].idUsuarioNavigation?.nombre + " " + datoRetorno[index].idUsuarioNavigation?.primerApellido + " " + datoRetorno[index].idUsuarioNavigation?.segundoApellido;

          this.padObservaciones.push(padObservacionesNew);
          
        }
      }

    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por getAllPadObservaciones");
      this.progressBar = false;
    }
  }

  // prettier-ignore
  async updatePadObservaciones(padObservaciones: PadObservaciones) {
    try {
      await this.padObservacionesService
        .update(padObservaciones)
        .toPromise();
        
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por updatePadObservaciones");
    }
  }

  // prettier-ignore
  async deletePadObservaciones(padObservaciones: PadObservaciones) {
    try {
      const datoRetorno = await this.padObservacionesService
        .delete(padObservaciones.id)
        .toPromise();
      this.getAllPadObservaciones();
    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por deletePadObservaciones");
    }
  }


}